import { useRef, useState } from 'react';

const SLIDER_ENTER_TIMEOUT_DURATION_MS = 225;
const GRID_ENTER_TIMEOUT_DURATION_MS = 225;
function useHover(layout) {
  const enterTimeoutRef = useRef(undefined);
  const [isHovered, setHovered] = useState(false);
  return [isHovered, {
    onPointerEnter() {
      if (enterTimeoutRef.current) {
        window.clearTimeout(enterTimeoutRef.current);
      }
      enterTimeoutRef.current = window.setTimeout(() => {
        setHovered(true);
      }, layout === "slider" ? SLIDER_ENTER_TIMEOUT_DURATION_MS : GRID_ENTER_TIMEOUT_DURATION_MS);
    },
    onPointerLeave() {
      if (enterTimeoutRef.current) {
        window.clearTimeout(enterTimeoutRef.current);
      }
      setHovered(false);
    }
  }];
}

export { useHover };
//# sourceMappingURL=hook.hover.js.map
